import { secondAxios } from "../../../../api/axios";

export const getAllUsers = async () => {
  const { data } = await secondAxios.get("/user");

  console.log(data);
  return data;
};

export const getAllActiveUsers = async () => {
  const { data } = await secondAxios.get("/user/active");

  console.log(data);
  return data;
};

export const addUser = async (user) => {
  const { data } = await secondAxios.post("/user/add-users", [user]);

  console.log(data);
  return data;
};

export const updateUser = async (id, body) => {
  const { data } = await secondAxios.patch("/user/" + id, body);

  console.log(data);
  return data;
};

export const deleteUser = async (id) => {
  const { data } = await secondAxios.delete("/user/" + id);

  console.log(data);
  return data;
};
